import script from "./DuplicatedTraficPlanDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./DuplicatedTraficPlanDialog.vue?vue&type=script&setup=true&lang=ts"

import "./DuplicatedTraficPlanDialog.vue?vue&type=style&index=0&id=44bfe369&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44bfe369"]])

export default __exports__